import { Point } from "./point";

export interface LineSegment {
  ends: [Point, Point];
}

export interface Closest {
  point: Point;
  dist: number;
}

export const LineSegment = {
  // Get the closest point on the line segment to the given point, and the distance to it.
  closest: (p: Point, seg: LineSegment): Closest => {
    const [a, b] = seg.ends;

    // Check for zero-length segments
    if (a.x === b.x && a.y === b.y) {
      return { point: a, dist: Point.dist(a, p) };
    }

    // Take these two handy vectors for distance calculations.
    const v = Point.sub(b, a);
    const u = Point.sub(a, p);

    // Get our parameteric distance along the line segment, from a to b.
    const t = -dot(v, u) / dot(v, v);

    // Clamp to the line segment.
    if (t >= 1) return { point: b, dist: Point.dist(b, p) };
    if (t <= 0) return { point: a, dist: Point.dist(a, p) };

    // We're inside the line segment. Interpolate by the parameter.
    const point = Point.add(a, Point.scale(v, t));
    const dist = Point.dist(p, point);
    return { point, dist };
  },
};

// Take a vector dot product.
// Yeah we know, these are called `Point`,
// but they've got the right data, and other helpful stuff.
function dot(a: Point, b: Point): number {
  return a.x * b.x + a.y * b.y;
}
